import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import UniversalShadowWrapperV2 from '../genericComponents/uiElements/UniversalShadowWrapperV2';

const TOGenericDownloadComp = forwardRef(({ htmlString }, ref) => {
  const shadowContentRef = useRef(null);
  const getBase64FromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};
const handlePrint = async () => {
  if (!shadowContentRef.current) return;

  // Convert logo to Base64 using your function
  const logoBase64 = await getBase64FromUrl("/img/mnm_logo_inner.png");

  const iframe = document.createElement("iframe");
  // ... (iframe styling setup remains the same) ...
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;

  doc.open();
  doc.write(`
      <html>
        <head>
          <title></title>
          
          <link rel="stylesheet" href="https://rsms.me/inter/inter.css">

          <style>
            @page { 
              margin: 5mm; 
              @top-left { content: ""; }
              @top-center { content: ""; }
              @top-right { content: ""; }
              @bottom-left { content: ""; }
              @bottom-center { content: ""; }
              @bottom-right { content: ""; }
            }
            html, body { 
              margin:0;
              padding:0;
              background:white;
              /* 2. Set the default font stack on the body */
              font-family: 'Inter', sans-serif;
            }
            a, a:link, a:visited {
              color: #007bff;
              text-decoration: none;
            }

            /* 2. Remove the red box/outline on click/focus */
            a:focus, a:active {
              outline: none;
              background-color: transparent;
            }

            /* PRINT-ONLY STYLES */
            @media print {
                
              /* Fixed header only visible in print */
              .print-header {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                padding: 10px 20px;
                display: flex;
                align-items: center;
                z-index: 9999;
                justify-content: flex-end;
                height: 60px;
              }
              .print-header img {
                height: 20px;
                margin-bottom: 25px !important; 
                margin-right: 20px;
                margin-top: 1px;
              }
              .print-footer {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 10px 20px;
                display: flex;
                align-items: center;
                margin-top: 50px !important;
                justify-content: flex-end;
                z-index: 9999;
                height: 50px;
                bottom: -5mm;
                
              }
              .print-footer img {
                height: 18px;
                // margin-bottom: 25px !important; 
                margin-right: 20px !important;
              }

              
              
              .slide {
                margin-bottom: 20px !important;
                padding: 20px !important;
                page-break-after: auto !important;
                break-inside: avoid !important;
                transform: scale(0.95);
                transform-origin: top left;
                box-shadow: none !important;
              }
              
            }
             /* Force all heading colors to black */
              h1, h2, h3, h4, h5, h6 {
                color: #000 !important;
              }

            ${shadowContentRef.current.__shadowStyles || ""}
          </style>
        </head>
        <body>

          
          
          <div class="print-footer">
          <img src="${logoBase64}" />
          </div>
         
         
          ${shadowContentRef.current.innerHTML}
          

          

           

        </body>
      </html>
    `);
  doc.close();
  // <div class="print-footer">
  //         <img src="${logoBase64}" />
  //   </div>
  
  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => document.body.removeChild(iframe), 100);
  };
};

  
  // Expose print function to parent via ref
  useImperativeHandle(ref, () => ({
    print: handlePrint,
  }));

  return (
    <div>
      <UniversalShadowWrapperV2
        htmlContent={htmlString}
        contentRef={el => { shadowContentRef.current = el; }}
      />
    </div>
    
  );
});

export default TOGenericDownloadComp;
